import { useEffect, useRef } from "react";
import { Textarea } from "@/components/ui/textarea";

export default function AutoGrowTextarea({ value, className = "", minHeight = 32, ...props }) {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    el.style.height = "auto";
    el.style.height = `${Math.max(minHeight, el.scrollHeight)}px`;
  }, [value, minHeight]);
  return (
    <Textarea
      ref={ref}
      value={value}
      rows={1}
      className={className}
      style={{ overflow: "hidden", resize: "none" }}
      {...props}
    />
  );
}
